import React, { useContext, useState } from "react";
import { Grid, TextField, Typography, Button, Checkbox, FormControlLabel } from "@mui/material";
import { MenuItem, Select, FormControl, } from "@mui/material";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setLoggedIn, setUserDetails ,setDecimalPlaces} from "../../../store/Slices/userSlice";
import { LoginApi, resetPasswordApi } from "../../../api/request/auth";
import '../../../components/styles/style.scss'
import { useTranslation } from "react-i18next";
import { setCookies } from "../../../services/Cookies";
import { ThemeContext } from "../../../context/ThemeContext";
import CryptoJS from "crypto-js";
import CompanyDetail from "./CompanyDetail";

const ConnectAccount = ({companyData}) => {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({ username: "", password: "" });
    const [savePassword, setSavePassword] = useState(false);
    const [isCompanyDetaildVisible, setIsCompanyDetailVisible] = useState(false);
    const [isForgetPasswordVisile, setForgetPasswordVisible] = useState(false)
    const [resetPassword, setResetPassword] = useState({ companyName: '', username: "", email: "" })
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true);
            const params = { login_type: "api", ...initialValues };
            const { data } = await LoginApi(params);

            if (data?.token) {
                toast.success("Login successful!");
                setCookies("username", params?.username, { path: "/", secure: true, sameSite: "strict", });
                setCookies("token", data?.token, { path: "/", secure: true, sameSite: "strict", });
                setCookies("refreshToken", data?.refreshToken, { path: "/", secure: true, sameSite: "strict", });
                setCookies("clientId", data?.client.id, { path: "/", secure: true, sameSite: "strict", });
                setCookies("gmtOffset", data?.gmtOffset, { path: "/", secure: true, sameSite: "strict", });

                localStorage.setItem("username", params?.username);

                if (savePassword) {
                    // console.log('before encryption', params.password, SECRET_KEY);
                    const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
                    const encryptedPassword = CryptoJS.AES.encrypt(params.password, CryptoJS.enc.Utf8.parse(SECRET_KEY), { iv: iv }).toString();

                    // Save the IV and encrypted password as a single string
                    const encryptedData = iv.toString(CryptoJS.enc.Base64) + encryptedPassword;
                    // console.log("Storing password:", encryptedPassword);
                    localStorage.setItem("password", encryptedData);
                } else {
                    localStorage.removeItem("password");
                }
                dispatch(setLoggedIn(true));
                dispatch(setUserDetails(data?.client));
                dispatch(setDecimalPlaces(data?.decimalPlacesForAmountFormatting));
                navigate("/dashboard");
            } else {
                toast.error("Login failed. Please check your credentials.");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "An error occurred while logging in.";
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCompanyDetailsToggle = () => {
        setIsCompanyDetailVisible(!isCompanyDetaildVisible);
    };

    const handleForgetPasswordToggle = () => {
        setForgetPasswordVisible(!isForgetPasswordVisile);
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (!resetPassword.companyName || !resetPassword.username || !resetPassword.email) {
            toast.error('Please fill out all fields!');
            return;
        }
        setIsLoading(true);
        try {
            console.log("Resetting password with data:", resetPassword);
            await resetPasswordApi(resetPassword);
            toast.success('Password reset successful');
            setResetPassword({ companyName: '', username: "", email: "" });
        } catch (error) {
            console.error("Error resetting password:", error);
            toast.error('An error occurred while resetting the password');
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            {!isCompanyDetaildVisible && !isForgetPasswordVisile ? (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} sx={{ padding: "15px" }}>
                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={12}><Typography variant="body1" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('connectToAccount')}</Typography></Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={3}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('username')}</Typography></Grid>
                            <Grid item xs={5}>
                                <TextField name="username" placeholder={t('username')} fullWidth size="small" required value={initialValues.username} onChange={(e) => setInitialValues({ ...initialValues, username: e.target.value })} className="custom-textfield" />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={3}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('password')}</Typography></Grid>
                            <Grid item xs={5}>
                                <TextField id="outlined-basic" variant="outlined" name="password" placeholder={t("enterPassword")} type="password" fullWidth size="small" required value={initialValues.password} onChange={(e) => setInitialValues({ ...initialValues, password: e.target.value })} className="custom-textfield" />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControlLabel control={<Checkbox className="custom-checkbox" onChange={(e) => { setSavePassword(e.target.checked); console.log("Save password checked:", e.target.checked); }} />} label={t('savePassword')} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" }, color: darkMode ? "var(--lightText)" : 'var(--black)' }} />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" sx={{ marginBottom: "15px" }}>
                            <Grid item xs={2}></Grid>
                            <Grid item xs={4}>
                                <Typography className="text-gray1" sx={{ fontSize: "0.775rem", textAlign: "right", marginRight: "5px", cursor: "pointer", }} onClick={handleForgetPasswordToggle}>{t('forgotPassword')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography className="text-primary" sx={{ fontSize: "0.775rem", textAlign: "left", cursor: "pointer", marginLeft: "5px", }} onClick={handleCompanyDetailsToggle}>{t('contactCompany')}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" >
                            <Grid item xs={3}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('server')}</Typography></Grid>
                            <Grid item xs={5}>
                                <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{companyData.companyName}-Demo</Typography>
                            </Grid>

                        </Grid>

                        <Grid container sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Grid item>
                                <Button type="submit" variant="contained" color="secondary" size="" sx={{ border: '1px solid green', marginTop: "20px", color: "white", padding: '5px', pl: 2, pr: 2, textTransform: "none", }}>{t('connectButton')}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form >
            ) : null}
            {isCompanyDetaildVisible && (
                <CompanyDetail onBackToLogin={handleCompanyDetailsToggle}  companyData={companyData}/>
            )}
            {isForgetPasswordVisile && (
                <>
                    <Grid container spacing={2} sx={{ padding: "15px" }}>
                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={12}><Typography variant="body1" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('resetPassword')}</Typography></Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('companyName')}</Typography></Grid>
                            <Grid item xs={5}>
                                <FormControl fullWidth size="small" className="custom-textfield">
                                    <Select value={resetPassword.companyName} onChange={(e) => setResetPassword({ ...resetPassword, companyName: e.target.value })} name="companyName" required>
                                        <MenuItem sx={{fontSize:'13px'}} value={companyData.companyName}>{companyData.companyName}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('email')}</Typography></Grid>
                            <Grid item xs={5}>
                                <TextField value={resetPassword.email} onChange={(e) => setResetPassword({ ...resetPassword, email: e.target.value })} name="email" type="email" placeholder={t('enterEmail')} fullWidth size="small" required className="custom-textfield" />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} alignItems="center" sx={{ marginBottom: "10px" }}>
                            <Grid item xs={4}><Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('username')}</Typography></Grid>
                            <Grid item xs={5}>
                                <TextField value={resetPassword.username} onChange={(e) => setResetPassword({ ...resetPassword, username: e.target.value })} name="username" type="text" placeholder={t("enterUsername")} fullWidth size="small" required className="custom-textfield" />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button type="submit" variant="contained" onClick={handleResetPassword} color="secondary" sx={{ border: "1px solid green", marginTop: "20px", color: "white", padding: "5px", pl: 2, pr: 2, textTransform: "none", }}>{t('resetPassword')}</Button>
                            <Button variant="outlined" color="secondary" onClick={() => setForgetPasswordVisible(false)} sx={{ border: "1px solid green", textTransform: "none", marginLeft: "10px", marginTop: "20px", padding: "5px", pl: 2, pr: 2 }} > {t('cancel')} </Button>
                        </Grid>
                    </Grid>
                </>
            )}

        </>
    );
};

export default ConnectAccount;
